import React from 'react';
// @ts-expect-error
const CalendarContext = React.createContext({});
export default CalendarContext;
